import React from 'react';
import { IconX } from '@tabler/icons-react';

const BaseModal = ({ 
  isOpen, 
  onClose, 
  children, 
  showCloseButton = true,
  className = "",
  overlayClassName = "",
  closeOnOverlayClick = true 
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 ${overlayClassName}`}
      onClick={handleOverlayClick}
    >
      <div className={`relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto ${className}`}>
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 transition-colors z-10"
          >
            <IconX size={20} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default BaseModal;